"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FoodBuyerOrder = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _useTracking = require("../../hooks/useTracking");
var _index = require("../OrderList/index");
var _Order = require("../Order");
var _Button = require("../Button");
var _LocaleProvider = require("../LocaleProvider");
var _constants = require("../../utils/constants");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var prefixCls = (0, _getPrefixCls.getPrefixCls)('food-buyer-order');
var FoodBuyerOrder = function FoodBuyerOrder(props) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var shopName = props.shopName,
    orderStatusText = props.orderStatusText,
    orderId = props.orderId,
    selectAction = props.selectAction,
    selectOrderText = props.selectOrderText,
    onSelectOrder = props.onSelectOrder,
    componentTrackingData = props.componentTrackingData;
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    panelOrderTracking = _useComponentTracking.result.panelOrder;
  var onOrderClick = function onOrderClick() {
    // 点击埋点
    onSelectOrder === null || onSelectOrder === void 0 ? void 0 : onSelectOrder(props);
    (panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingClick) && tracker.click(panelOrderTracking.trackingClick);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: prefixCls
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-shop")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-shop__name")
  }, /*#__PURE__*/_react.default.createElement("span", null, shopName)), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-shop__type")
  }, orderStatusText)), /*#__PURE__*/_react.default.createElement(_Order.Order, (0, _extends2.default)({}, props, {
    key: orderId,
    orderCardType: _index.OrderCardType.foodCardInList,
    orderStatusText: "",
    className: "".concat(prefixCls)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-buttons"),
    onClick: function onClick(element) {
      return element.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "".concat(prefixCls, "-button"),
    type: "primary",
    onClick: onOrderClick,
    action: selectAction,
    text: selectOrderText || trans(_constants.SELECT_ORDER_TEXT)
  })));
};
exports.FoodBuyerOrder = FoodBuyerOrder;